
/*
 * @Author: huangying
 * @Date: 2021-12-30 13:53:27
 * @Last Modified by: huxianyong
 * @Last Modified time: 2023-06-06 17:47:04
 */

export default function company_page() {
  return `<div class="content">
  <p class="fs-48 company_page_title">公司简介</p>
  <div class='pageContent'>
  <p class="fs-20 company_page_word">
  <span class='dot'></span>
  <span class="flex_1">四川纽睿科技有限公司是一家专注于医疗美容行业的SaaS服务商， 其开发的睿美云一体化经营管理平台以CRM为核心，打通外营销、内运营、ERP、HIS、渠道分销各环节，为医美行业提供覆盖院内经营、客户体验、售后维护等95%的场景服务，助力机构全流程数字化运营，精细化客户经营，数据驱动管理流程优化，形成可落地执行的解决方案。  </span>
  
  </p>
  <p class="fs-20 company_page_word"> 
  <span class='dot'></span>
  <span class="flex_1">睿美云SaaS通过数字化管理提升企业的决策能力和效率，帮助一线执行层突破业绩与服务的新高度。帮助机构实现千人千面的服务能力，提升顾客满意度，从而提高复购率，最终实现健康可持续发展。</span>
  </p>
  <p class="fs-20 company_page_word">  
  <span class='dot'></span>
  <span class="flex_1">四川纽睿科技有限公司以创新为己任，睿美云从0到1由资深业务与研发团队打造，享有完整知识产权50余项。在提供强有力的智能化医美SaaS产品的同时，也为客户提供医美产业资源以及业务咨询服务，未来旨在为机构提供从获客到客户转化运营再到供应链管理等全生态平台的搭建和发展。</span>
  </p>
    </div>
    </div>
  `
}
